import React, { useState } from "react";
import { useParams, Link } from "react-router-dom";

/* ============================================================
   DATA SOURCE WITH OPTIONAL SCREENSHOT MAPPINGS
============================================================ */
const ACCOUNTS_DATA = [
  {
    account_name: "account1",
    feedback_percentage: "100%",
    feedback_score: 462,
    account_image: "https://ik.imagekit.io/g9mnvfpan/blurr1.png",
    platform: "eBay UK",
    top_summary: {
      listing_views_90d: 25834,
      sales_90d: "£5,428.67",
      orders_90d: 564,
      orders_to_dispatch: 18,
      orders_overdue: 3,
      unread_member_messages: 5,
      eligible_to_send_offers: 8,
    },
    listings: {
      active_listings: 264,
      drafts: 7,
      auctions_ending_today: 3,
      unsold_and_not_relisted: 12,
    },
    orders: {
      awaiting_postage_print_postage_label: 18,
      all_open_returns_replacements: 2,
      open_cancellations: 0,
      awaiting_payment: 3,
      posted_and_awaiting_your_feedback: 156,
      orders_eligible_for_combined_purchase: 21,
    },
    sales: {
      today: "£176.45",
      last_7_days: "£1,243.78",
      last_31_days: "£5,428.67",
      last_31_days_growth: "+24.6%",
      last_90_days: "£5,428.67",
      last_90_days_growth: "+38.9%",
    },
  },
  {
    account_name: "account2",
    feedback_percentage: "100%",
    feedback_score: 44,
    account_image: "https://ik.imagekit.io/g9mnvfpan/blurr2.png",
    platform: "eBay UK",
    top_summary: {
      listing_views_90d: 98742,
      sales_90d: "£32,845.60",
      orders_90d: 468,
      orders_to_dispatch: 18,
      unread_member_messages: 3,
    },
    listings: {
      active_listings: 287,
      drafts: 12,
      auctions_ending_today: 7,
      unsold_and_not_relisted: 8,
    },
    orders: {
      awaiting_postage_print_postage_label: 18,
      all_open_returns_replacements: 2,
      open_cancellations: 1,
      awaiting_payment: 3,
      posted_and_awaiting_your_feedback: 412,
      orders_eligible_for_combined_purchase: 14,
    },
    sales: {
      today: "£1,245.80",
      last_7_days: "£9,872.60",
      last_31_days: "£16,284.35",
      last_31_days_growth: "+28.4%",
      last_90_days: "£32,845.60",
      last_90_days_growth: "+45.7%",
    },
  },
  {
    account_name: "account3",
    feedback_percentage: "100%",
    feedback_score: 268,
    account_image: "https://ik.imagekit.io/g9mnvfpan/blurr3.png",
    platform: "eBay UK",
    top_summary: {
      listing_views_90d: 36782,
      sales_90d: "£6,482.75",
      orders_90d: 235,
      orders_to_dispatch: 12,
      orders_overdue: 3,
      unread_member_messages: 7,
      eligible_to_send_offers: 14,
      requests_and_disputes: 2,
    },
    listings: {
      drafts: 5,
      active_listings: 218,
      with_questions: 4,
      with_open_offers_from_buyers: 18,
      all_auctions: 6,
      with_reserve_met: 3,
      auctions_ending_today: 7,
      buy_it_now_renewing_today: 15,
      scheduled_listings: 6,
      unsold_and_not_relisted: 28,
    },
    orders: {
      awaiting_postage_print_postage_label: 12,
      all_open_returns_replacements: 1,
      open_cancellations: 0,
      awaiting_payment: 3,
      posted_and_awaiting_your_feedback: 24,
      orders_eligible_for_combined_purchase: 31,
    },
    sales: {
      today: "£148.36",
      last_7_days: "£1,127.42",
      last_31_days: "£2,974.18",
      last_31_days_growth: "+32.6%",
      last_90_days: "£6,482.75",
      last_90_days_growth: "+48.9%",
    },
  },
  {
    account_name: "account4",
    feedback_percentage: "100%",
    feedback_score: 326,
    account_image: "https://ik.imagekit.io/g9mnvfpan/blurr4.png",
    platform: "eBay UK",
    top_summary: {
      listing_views_90d: 58362,
      sales_90d: "£8,925.64",
      orders_90d: 642,
      orders_to_dispatch: 28,
      orders_overdue: 3,
    },
    listings: {
      drafts: 8,
      active_listings: 148,
      with_questions: 7,
      with_open_offers_from_buyers: 12,
      all_auctions: 5,
      with_reserve_met: 3,
      auctions_ending_today: 6,
      buy_it_now_renewing_today: 14,
      scheduled_listings: 5,
      unsold_and_not_relisted: 10,
    },
    orders: {
      awaiting_postage_print_postage_label: 28,
      all_open_returns_replacements: 2,
      open_cancellations: 0,
      awaiting_payment: 4,
      posted_and_awaiting_your_feedback: 412,
      orders_eligible_for_combined_purchase: 37,
    },
    sales: {
      today: "£286.74",
      last_7_days: "£1,924.60",
      last_31_days: "£4,248.17",
      last_31_days_growth: "+28.6%",
      last_90_days: "£8,925.64",
      last_90_days_growth: "+37.2%",
    },
  },
];

// Helper to format key object names into clean titles
const formatKey = (key) =>
  key.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());

/* ============================================================
   ACCOUNT DETAIL COMPONENT
============================================================ */
export default function AccountDetail() {
  const { accountName } = useParams();
  const [showImageModal, setShowImageModal] = useState(false);

  // Find account by route param or default to first item
  const account =
    ACCOUNTS_DATA.find(
      (acc) => acc.account_name.toLowerCase() === accountName?.toLowerCase()
    ) || ACCOUNTS_DATA[0];

  if (!account) {
    return (
      <div style={styles.errorContainer}>
        <h2>Account Not Found</h2>
        <Link to="/portfolio" style={styles.backBtn}>
          ← Back to Portfolio
        </Link>
      </div>
    );
  }

  return (
    <div style={styles.pageWrapper}>
      {/* Top Header Navigation */}
      <div style={styles.navContainer}>
        <Link to="/portfolio" style={styles.backLink}>
          ← Back to All Accounts
        </Link>
      </div>

      {/* Main Account Header */}
      <header style={styles.headerSection}>
        <div>
          <span style={styles.platformBadge}>{account.platform || "E-Commerce Account"}</span>
          <h1 style={styles.accountTitle}>@{account.account_name}</h1>
          <div style={styles.feedbackRow}>
            <span style={styles.feedbackBadge}>
              ★ {account.feedback_percentage} Positive Feedback
            </span>
            <span style={styles.scoreText}>({account.feedback_score} total reviews)</span>
          </div>
        </div>

        <Link to="/contact" style={styles.contactBtn}>
          Request Similar Store Setup
        </Link>
      </header>

      {/* Hero Screenshot Showcase */}
      <section style={styles.imageSection}>
        <div style={styles.imageCard} onClick={() => setShowImageModal(true)}>
          <img
            src={account.account_image}
            alt={`${account.account_name} proof dashboard`}
            style={styles.screenshotImg}
          />
          <div style={styles.imageOverlay}>
            <span>Click to expand full account proof 🔍</span>
          </div>
        </div>
      </section>

      {/* Sales Performance Cards (Sales KPIs) */}
      <section style={styles.sectionMargin}>
        <h3 style={styles.sectionHeader}>Sales Performance & Revenue</h3>
        <div style={styles.grid4}>
          <div style={styles.kpiCard}>
            <span style={styles.kpiLabel}>Today's Sales</span>
            <strong style={styles.kpiValue}>{account.sales.today}</strong>
          </div>
          <div style={styles.kpiCard}>
            <span style={styles.kpiLabel}>Last 7 Days</span>
            <strong style={styles.kpiValue}>{account.sales.last_7_days}</strong>
          </div>
          <div style={styles.kpiCard}>
            <span style={styles.kpiLabel}>Last 31 Days</span>
            <strong style={styles.kpiValue}>{account.sales.last_31_days}</strong>
            <small style={styles.growthText}>{account.sales.last_31_days_growth} growth</small>
          </div>
          <div style={{ ...styles.kpiCard, border: "1px solid rgba(253, 129, 16, 0.4)" }}>
            <span style={styles.kpiLabel}>Last 90 Days Total</span>
            <strong style={{ ...styles.kpiValue, color: "#fd8110" }}>{account.sales.last_90_days}</strong>
            <small style={styles.growthText}>{account.sales.last_90_days_growth} growth</small>
          </div>
        </div>
      </section>

      {/* Operational Overview Grid */}
      <div style={styles.grid2}>
        {/* Listings Data Block */}
        <div style={styles.dataBlock}>
          <h3 style={styles.blockTitle}>Listing Inventory Breakdown</h3>
          <div style={styles.dataList}>
            {Object.entries(account.listings).map(([key, val]) => (
              <div style={styles.dataRow} key={key}>
                <span style={styles.rowKey}>{formatKey(key)}</span>
                <strong style={styles.rowVal}>{val}</strong>
              </div>
            ))}
          </div>
        </div>

        {/* Orders Data Block */}
        <div style={styles.dataBlock}>
          <h3 style={styles.blockTitle}>Orders & Dispatch Status</h3>
          <div style={styles.dataList}>
            {Object.entries(account.orders).map(([key, val]) => (
              <div style={styles.dataRow} key={key}>
                <span style={styles.rowKey}>{formatKey(key)}</span>
                <strong style={styles.rowVal}>{val}</strong>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Top Summary Metrics */}
      <section style={styles.sectionMargin}>
        <div style={styles.dataBlock}>
          <h3 style={styles.blockTitle}>3-Month Summary Insights</h3>
          <div style={styles.grid3}>
            {Object.entries(account.top_summary).map(([key, val]) => (
              <div style={styles.summaryBox} key={key}>
                <span style={styles.summaryKey}>{formatKey(key)}</span>
                <strong style={styles.summaryVal}>{val}</strong>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox Screenshot Modal */}
      {showImageModal && (
        <div style={styles.modalBackdrop} onClick={() => setShowImageModal(false)}>
          <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <button style={styles.closeBtn} onClick={() => setShowImageModal(false)}>
              ✕
            </button>
            <img
              src={account.account_image}
              alt={`${account.account_name} full view`}
              style={styles.fullModalImg}
            />
          </div>
        </div>
      )}
    </div>
  );
}

/* ============================================================
   STYLES CONFIGURATION
============================================================ */
const styles = {
  pageWrapper: {
    minHeight: "100vh",
    backgroundColor: "#06060a",
    color: "#ffffff",
    fontFamily: "'Outfit', sans-serif",
    padding: "100px 24px 60px",
   
    margin: "0 auto",
  },
  navContainer: {
    marginBottom: "24px",
  },
  backLink: {
    color: "#fd8110",
    textDecoration: "none",
    fontSize: "14px",
    fontWeight: "600",
  },
  headerSection: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    flexWrap: "wrap",
    gap: "20px",
    marginBottom: "32px",
    paddingBottom: "24px",
    borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
  },
  platformBadge: {
    background: "rgba(253, 129, 16, 0.15)",
    color: "#fd8110",
    padding: "4px 12px",
    borderRadius: "9999px",
    fontSize: "12px",
    fontWeight: "700",
    textTransform: "uppercase",
  },
  accountTitle: {
    fontSize: "clamp(2rem, 3.5vw, 3rem)",
    fontWeight: "800",
    margin: "8px 0",
    letterSpacing: "-0.02em",
  },
  feedbackRow: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  feedbackBadge: {
    background: "#10b981",
    color: "#000000",
    padding: "3px 10px",
    borderRadius: "6px",
    fontWeight: "700",
    fontSize: "13px",
  },
  scoreText: {
    color: "rgba(255, 255, 255, 0.6)",
    fontSize: "13.5px",
  },
  contactBtn: {
    padding: "12px 24px",
    background: "#ffffff",
    color: "#000000",
    borderRadius: "9999px",
    textDecoration: "none",
    fontWeight: "700",
    fontSize: "14px",
  },
  imageSection: {
    marginBottom: "40px",
  },
  imageCard: {
    position: "relative",
    borderRadius: "20px",
    overflow: "hidden",
    border: "1px solid rgba(255, 255, 255, 0.12)",
    cursor: "pointer",
    
  },
  screenshotImg: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    display: "block",
  },
  imageOverlay: {
    position: "absolute",
    inset: 0,
    background: "rgba(0,0,0,0.4)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    opacity: 0,
    transition: "opacity 200ms ease",
    color: "#fff",
    fontWeight: "600",
  },
  sectionMargin: {
    marginBottom: "40px",
  },
  sectionHeader: {
    fontSize: "20px",
    fontWeight: "700",
    marginBottom: "16px",
  },
  grid4: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: "16px",
  },
  grid3: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "16px",
  },
  grid2: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(340px, 1fr))",
    gap: "24px",
    marginBottom: "40px",
  },
  kpiCard: {
    background: "rgba(16, 16, 24, 0.8)",
    border: "1px solid rgba(255, 255, 255, 0.08)",
    borderRadius: "16px",
    padding: "20px",
  },
  kpiLabel: {
    display: "block",
    fontSize: "12px",
    color: "rgba(255, 255, 255, 0.5)",
    textTransform: "uppercase",
    marginBottom: "6px",
  },
  kpiValue: {
    fontSize: "24px",
    fontWeight: "800",
    color: "#ffffff",
  },
  growthText: {
    display: "block",
    color: "#10b981",
    fontSize: "12px",
    fontWeight: "600",
    marginTop: "4px",
  },
  dataBlock: {
    background: "rgba(16, 16, 24, 0.8)",
    border: "1px solid rgba(255, 255, 255, 0.08)",
    borderRadius: "20px",
    padding: "24px",
  },
  blockTitle: {
    fontSize: "18px",
    fontWeight: "700",
    marginBottom: "20px",
    color: "#fd8110",
  },
  dataList: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  dataRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingBottom: "10px",
    borderBottom: "1px solid rgba(255, 255, 255, 0.05)",
  },
  rowKey: {
    color: "rgba(255, 255, 255, 0.7)",
    fontSize: "14px",
  },
  rowVal: {
    fontWeight: "700",
    fontSize: "15px",
  },
  summaryBox: {
    background: "rgba(255, 255, 255, 0.03)",
    padding: "16px",
    borderRadius: "12px",
    border: "1px solid rgba(255, 255, 255, 0.05)",
  },
  summaryKey: {
    display: "block",
    fontSize: "11px",
    color: "rgba(255, 255, 255, 0.5)",
    textTransform: "uppercase",
    marginBottom: "4px",
  },
  summaryVal: {
    fontSize: "16px",
    fontWeight: "700",
    color: "#ffffff",
  },
  modalBackdrop: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.9)",
    zIndex: 2000,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "20px",
  },
  modalContent: {
    position: "relative",
    maxWidth: "1000px",
    width: "100%",
  },
  fullModalImg: {
    width: "100%",
    borderRadius: "12px",
  },
  closeBtn: {
    position: "absolute",
    top: "-40px",
    right: 0,
    background: "none",
    border: "none",
    color: "#ffffff",
    fontSize: "24px",
    cursor: "pointer",
  },
  errorContainer: {
    padding: "120px 20px",
    textAlign: "center",
    color: "#fff",
  },
  backBtn: {
    color: "#fd8110",
    textDecoration: "none",
    marginTop: "16px",
    display: "inline-block",
  },
};